// extracted by mini-css-extract-plugin
module.exports = {"row":"FaqSection_row__DftQH","rowHeader":"FaqSection_rowHeader__gWxOt","isExpanded":"FaqSection_isExpanded__QCmQb","arrow":"FaqSection_arrow__jkzak"};